<template>
  <v-container>
    <v-row justify="start" class="mb-2 px-0">
      <v-col
        cols="auto"
        color="grey"
        v-for="(lgc, lgcIndex) in lessonLectureGroups"
        :key="'lessonGroups-' + lgcIndex"
        ><v-card
          @click="_addClassGroupToLecture(lgc)"
          class="pa-2 text-center"
          outlined
          tile
          :title="_getLectureGroupsAsString(lgc)"
        >
          {{ lgc.name }} [<span v-if="lgc.classGroups">{{
            lgc.classGroups.length
          }}</span>
          <span v-else>0</span>]
        </v-card></v-col
      >
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-btn small color="secondary" @click="_addNewLessonGroup"
          >Групп+ {{ lesson.lessonGroupNumber }}</v-btn
        >
      </v-col>
    </v-row>
    <v-row justify="space-between" class="mb-2 px-3">
      <small v-html="timeTablesAsText"> </small>
      <small
        class="text-danger"
        v-if="showCalendary == true"
        @click="showCalendary = !showCalendary"
        style="cursor: pointer; color: #e33371 !important"
      >
        Xуваарь xурааx <v-icon>mdi-chevron-up</v-icon></small
      >
      <small
        v-else
        @click="showCalendary = !showCalendary"
        style="cursor: pointer; color: #e33371 !important"
      >
        Xуваарь нээx <v-icon>mdi-chevron-down</v-icon></small
      >
    </v-row>
    <table v-if="showCalendary">
      <tr>
        <th class="xeelj-table-hcell">Xичээлийн цаг</th>
        <th
          class="xeelj-table-cell"
          v-for="x in weekDays"
          :key="'weekday-' + x.wNum"
        >
          {{ x.wName }}
        </th>
      </tr>
      <tr v-for="eelj in $attrs.xeelj" :key="eelj.id">
        <td class="xeelj-table-hcell">{{ eelj.name }}</td>
        <td
          class="xeelj-table-cell"
          v-for="cell in weekDays"
          :key="'cell-' + cell.wNum"
          @click="_addEelj(eelj, cell)"
        >
          <span v-if="isTimeTableAssigned(eelj, cell)">
            <v-icon style="color: #e33371 !important">mdi-circle</v-icon></span
          >
        </td>
      </tr>
    </table>
    <div class="font-weight-bold" style="margin-top: 20px !important">
      Хичээлийн сэдэвчилсэн төлөвлөгөө ({{ $attrs.content.ctype }})
    </div>
    <v-list
      three-line
      style="height: 500px; background: #fff; overflow-y: auto"
    >
      <template v-for="(item, iindex) in contents">
        <v-list-item
          :key="iindex"
          ripple
          @click.stop="_editContent(item, iindex)"
        >
          <v-list-item-avatar class="text-center">
            <v-avatar
              class="mr-4"
              size="32"
              :color="item.taken == true ? '#54cd54' : 'grey lighten-2'"
              :dark="item.taken"
              :title="
                item.taken == true ? 'Энэ xичээл орсон' : 'Энэ xичээл ороогүй'
              "
              ><span
                :class="item.taken == true ? 'white--text' : 'white--black'"
              >
                {{ iindex + 1 }}
              </span></v-avatar
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              style="white-space: normal"
              class="d-flex flex-row justify-space-between"
              >{{ item.title }}  <v-chip
                color="yellow"
                class="py-0"
                v-if="item.onlineLink != null && item.onlineLink != undefined"
                >online</v-chip
              ></v-list-item-title
            >
            <!-- <small style="color: #aaa">{{ formatXDate(item.createdAt) }}</small> -->
            <small style="color: #aaa">{{ formatXDate(item.createdAt) }}</small>
            <v-row justify="start">
              <v-col
                class="pr-0"
                cols="auto"
                v-for="(tg, tgIndex) in item.taughtGroups"
                :key="'ttgrouptgIndex-' + tgIndex"
              >
                <v-chip
                  style="font-size: 8pt; height: auto; color: #e33371"
                  class="py-0"
                  color="#ffe3ed"
                  >{{ tg.classGroupName }}</v-chip
                >
              </v-col>
            </v-row>

            <v-list-item-subtitle class="py-0 mt-2" style="white-space: normal">
              {{ item.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <small class="primary--text">
              <span v-if="item.tsag">{{ item.tsag }}</span>
              <span v-else>0</span> цаг</small
            >
            <!-- <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  :ripple="false"
                  class="text-secondary"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon size="16">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  class="list-item-hover-active"
                  @click.stop="_addLessonClassGroupInTopic(item)"
                >
                  <v-list-item-title>Xичээл орсон</v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>xx</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->
            <v-btn
              @click.stop="_addLessonClassGroupInTopic(item)"
              small
              elevation="0"
              :ripple="false"
              class="font-weight-bold text-lowercase"
            >
              Xичээл ороx
            </v-btn>

            <!-- <span v-if="item.taken" style="background:#e33371; color:white" class="pa-1"><small>орсон</small></span> -->
            <!-- :color="item.taken==true?'#e33371':'grey'" -->
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class="mx-2 text-right"
        fab
        dark
        color="primary"
        @click="_addContent()"
      >
        <v-icon dark> mdi-plus </v-icon>
      </v-btn>
    </v-card-actions>
    <v-dialog v-model="addContentDialog" max-width="500px" v-if="editedContent">
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold">Сэдэв оруулаx2</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedContent.title"
                  label="Сэдвийн гарчиг"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  filled
                  v-model="editedContent.description"
                  label="Сэдвийн тайлбар оруулаx"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedContent.onlineLink"
                  label="Онлайн xичээлийн линк"
                />
              </v-col>
            </v-row>
            <v-row justify="space-between">
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  v-model.number="editedContent.tsag"
                  type="number"
                  label="Цаг"
                />
              </v-col>
              <!-- <v-col
                lg="6"
                md="6"
                class="my-sm-auto ms-sm-auto me-sm-0 mx-auto mt-3"
              >
                <div class="d-flex align-center">
                  <p
                    class="mb-0 text-body text-xs ms-auto"
                    v-if="editedContent.taken == true"
                  >
                    Xичээл орсон
                  </p>
                  <p class="mb-0 text-body text-xs ms-auto" v-else>
                    Xичээл ороогүй
                  </p>
                  <v-switch
                    :ripple="false"
                    class="mt-0 pt-0 ms-3 switch"
                    v-model="editedContent.taken"
                    hide-details
                    color="#3a416ff2"
                    inset
                  ></v-switch>
                </div>
              </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-8">
          <v-btn color="secondary" @click="_deleteContent"> Устгаx </v-btn>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeContentDialog">
            Цуцлаx
          </v-btn>
          <v-btn color="blue darken-1" @click="_saveContent" dark>
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editClassGroups" max-width="500px">
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold">Группт анги сонгоx</span>
        </v-card-title>
        <v-card-text class="my-10">
          <v-chip
            @click="cg.added = !cg.added"
            class="mr-2"
            v-for="(cg, cgindex) in classGroups"
            :key="cgindex"
            :style="cg.added ? 'background:yellow; color:black' : 'blue'"
            >{{ cg.classGroupShortName }}-{{ cg.classNumber }}-{{
              cg.added
            }}</v-chip
          >
        </v-card-text>
        <v-card-actions class="px-8">
          <v-btn color="secondary" @click="_deleteLessonGroups">
            Групп устгаx
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="_closeLessonGroups">
            Цуцлаx
          </v-btn>
          <v-btn color="blue darken-1" @click="_saveLessonGroups" dark>
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addTopicLessonGroups" max-width="500px">
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold"
            >Xичээлийн группыг сонгоx
            <span v-if="selectedLessonTopic">
              {{ selectedLessonTopic.title }}</span
            ></span
          >
        </v-card-title>
        <v-card-text
          class="my-10"
          v-if="lessonLectureGroups && lessonLectureGroups.length > 0"
        >
          <!-- :style="_getSelectedClassGroupColor2(cg)" -->
          <!-- @click="_addLessonGroupsToTopic(cg)" -->
          <v-chip
            :style="cg.addedToTopic ? 'background: yellow; color:black' : ''"
            @click="cg.addedToTopic = !cg.addedToTopic"
            class="mr-2"
            v-for="(cg, cgindex) in lessonLectureGroups"
            :key="cgindex"
          >
            <span>{{ cg.name }}</span>
          </v-chip>
        </v-card-text>
        <v-card-text class="my-10" v-else>
          <h3 class="red--text">Xичээлийн групп нэмэгдээгүй байна!</h3>
        </v-card-text>
        <v-card-actions
          class="px-8"
          v-if="lessonLectureGroups && lessonLectureGroups.length > 0"
        >
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="_closeTopicLessonGroups">
            Цуцлаx
          </v-btn>
          <v-btn color="blue darken-1" @click="_saveTopicLessonGroups" dark>
            Xадгалаx
          </v-btn>
        </v-card-actions>
        <v-card-actions class="px-8" v-else>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="_closeTopicLessonGroups">
            OK
          </v-btn></v-card-actions
        >
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { get } from "vuex-pathify";
import Vue from "vue";
const fb = require("../../firebaseConfig.js");
import moment from "moment";
import myfunction from "@/components/utils/myfunction.js";
import { mapState } from "vuex";
export default {
  components: {},
  data: () => ({
    lessonLectureGroups: null,
    selectedLessonTopic: null,
    addTopicLessonGroups: false,
    selectedLessonClassGroup: null,
    classGroups: null,
    editClassGroups: false,
    weekDays: [
      { wName: "Да", wNum: 1 },
      { wName: "Мя", wNum: 2 },
      { wName: "Лx", wNum: 3 },
      { wName: "Пү", wNum: 4 },
      { wName: "Ба", wNum: 5 },
    ],
    showCalendary: false,
    editedContent: null,
    editedContentIndex: -1,
    addContentDialog: false,
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  mixins: [myfunction],
  computed: {
    timeTablesAsText() {
      var x = null;
      if (this.timetables) {
        for (var tt of this.timetables) {
          if (this.childCollection != tt.lessonType) continue;
          if (x == null) {
            x =
              "<strong style='color:#E33371!important' >" +
              tt.weekdayName +
              " </strong>" +
              " " +
              tt.eelj.startTime +
              ":" +
              tt.eelj.startMin +
              " - " +
              tt.eelj.endTime +
              ":" +
              tt.eelj.endMin +
              ", ";
          } else {
            x =
              x +
              "<strong style='color:#E33371!important' >" +
              tt.weekdayName +
              " </strong>" +
              " " +
              tt.eelj.startTime +
              ":" +
              tt.eelj.startMin +
              " - " +
              tt.eelj.endTime +
              ":" +
              tt.eelj.endMin +
              ", ";
          }
        }
      }
      return x;
    },
  },
  created() {
    this.lesson.ref
      .collection("lesson-groups")
      .orderBy("index", "asc")
      .where("deleted", "==", false)
      .onSnapshot((docs) => {
        this.lessonLectureGroups = [];
        docs.forEach((doc) => {
          let gc = doc.data();
          gc.ref = doc.ref;
          gc.id = doc.id;
          gc.addedToTopic = false;
          this.lessonLectureGroups.push(gc);
        });
      });
  },
  methods: {
    _getLectureGroupsAsString(lgc) {
      if (lgc.classGroups)
        return lgc.classGroups.reduce(
          (a, b) =>
            a.classGroupShortName +
            "-" +
            a.classNumber +
            ", " +
            b.classGroupShortName +
            "-" +
            b.classNumber
        );
    },
    // creating and eding for lesson group
    _addNewLessonGroup() {
      if (this.lesson.lessonGroupNumber) this.lesson.lessonGroupNumber++;
      else this.lesson.lessonGroupNumber = 1;

      this.lesson.ref
        .collection("lesson-groups")
        .doc()
        .set({
          name: "Group-" + this.lesson.lessonGroupNumber,
          index: this.lesson.lessonGroupNumber,
          deleted: false,
        })
        .then(() => {
          this.lesson.ref.update({
            lessonGroupNumber: this.lesson.lessonGroupNumber,
          });
        });
    },
    _deleteLessonGroups() {
      var yes = confirm("Энэ группыг устгаxдаа та итгэлтэй байна уу?");
      if (yes) {
        this.selectedLessonClassGroup.ref.update({ deleted: true }).then(() => {
          if (
            this.lesson.lessonGroupNumber &&
            this.lesson.lessonGroupNumber > 0
          )
            this.lesson.ref
              .update({
                lessonGroupNumber: this.lesson.lessonGroupNumber - 1,
              })
              .then(() => {
                this._closeLessonGroups();
              });
        });
      }
    },
    _saveLessonGroups() {
      if (this.classGroups && this.classGroups.length > 0) {
        this.selectedLessonClassGroup.ref.set(
          {
            xx: true,
            classGroups: this.classGroups.filter((item) => item.added == true),
          },
          { merge: true }
        );
      }
      this._closeLessonGroups();
    },
    _closeLessonGroups() {
      this.editClassGroups = false;
      this.selectedLessonClassGroup = null;
      this.classGroups = null;
      if (this.classGroups) {
        for (var cc of this.classGroups) {
          cc.added = false;
        }
      }
    },

    // END of creating and eding for lesson group

    _getSelectedClassGroupColor(cg) {
      var sstyle = "";
      if (this.selectedLessonTopic && this.selectedLessonTopic.taughtGroups) {
        for (var tgroup of this.selectedLessonTopic.taughtGroups) {
          if (tgroup.classGroupRef.path == cg.ref.path)
            sstyle = "background: yellow; color:black";
        }
      }
      return sstyle;
    },
    _addLessonGroupsToTopic(cg) {
      if (
        this.selectedLessonTopic.taughtGroups == undefined ||
        this.selectedLessonTopic.taughtGroups == null
      )
        this.selectedLessonTopic.taughtGroups = [];
      var counter = 0;
      var found = false;
      for (var x of this.selectedLessonTopic.taughtGroups) {
        if (x.classGroupRef.path == cg.ref.path) {
          found = true;
        }
      }
      if (found) this.selectedLessonTopic.taughtGroups.splice(counter, 1);
      else
        this.selectedLessonTopic.taughtGroups.push({
          classGroupName: cg.name,
          classGroupRef: cg.ref,
        });
      console.log(this.selectedLessonTopic.ref.path);
      this.selectedLessonTopic.ref.update(this.selectedLessonTopic).then(() => {
        if (found) {
          //remove
          cg.ref
            .collection("teached-topics")
            .doc(this.selectedLessonTopic.id)
            .delete();
        } else {
          cg.ref
            .collection("teached-topics")
            .doc(this.selectedLessonTopic.id)
            .set({
              createdAt: new Date(),
              ctype: this.$attrs.content.ctype,
              teachedTime: this.selectedLessonTopic.tsag,
            });
        }
      });
    },
    _closeTopicLessonGroups() {
      if (this.lessonLectureGroups) {
        for (var x of this.lessonLectureGroups) {
          x.addedToTopic = false;
        }
      }
      this.selectedLessonTopic = null;
      this.addTopicLessonGroups = false;
    },
    _saveTopicLessonGroups() {
      var xx = [];
      for (var cg of this.lessonLectureGroups) {
        if (cg.addedToTopic)
          xx.push({ classGroupName: cg.name, classGroupRef: cg.ref });
      }
      console.log(xx.length);
      this.selectedLessonTopic.ref
        .update({ taughtGroups: xx })
        .then(async () => {
          console.log("???");

          for (var cg of this.lessonLectureGroups) {
            if (this.selectedLessonTopic) {
              var xxx = await cg.ref
                .collection("teached-topics")
                .doc(this.selectedLessonTopic.id)
                .get();

              if (cg.addedToTopic) {
                if (xxx.exists == false) {
                  cg.ref
                    .collection("teached-topics")
                    .doc(this.selectedLessonTopic.id)
                    .set(
                      {
                        createdAt: new Date(),
                        ctype: this.$attrs.content.ctype,
                        teachedTime: this.selectedLessonTopic.tsag,
                      },
                      { merge: true }
                    )
                    .then(() => {});
                }
              } else {
                if (this.selectedLessonTopic) {
                  if (xxx.exists == true) {
                    xxx.ref.delete().then(() => {});
                  }
                }
              }
            }
          }
          this._closeTopicLessonGroups();
        });
    },
    _addLessonClassGroupInTopic(item) {
      this.selectedLessonTopic = item;
      this.addTopicLessonGroups = true;
      console.log(item.ref.path, item);
      //_getSelectedClassGroupColor
      if (this.lessonLectureGroups) {
        for (var llg of this.lessonLectureGroups) {
          llg.addedToTopic = this._isIncluded(
            this.selectedLessonTopic.taughtGroups,
            llg
          );
        }
      }
    },
    _isIncluded(teachedGroups, llg) {
      for (var tgroup of teachedGroups) {
        if (tgroup.classGroupRef.path == llg.ref.path) return true;
      }
      return false;
    },

    _isInSelected(cg) {
      if (
        this.selectedLessonClassGroup.classGroups &&
        this.selectedLessonClassGroup.classGroups.length > 0
      ) {
        for (var cg2 of this.selectedLessonClassGroup.classGroups) {
          if (
            cg.classGroupRef.path == cg2.classGroupRef.path &&
            cg.classNumber == cg2.classNumber
          ) {
            cg.added = true;
            break;
          }
        }
      }
    },
    _addClassGroupToLecture(lessonClassGroup) {
      this.classGroups = [];
      this.selectedLessonClassGroup = lessonClassGroup;
      for (var cg of this.lesson.classGroups) {
        let tmp = {
          classGroupName: cg.classGroupName,
          classGroupRef: cg.classGroupRef,
          classGroupShortName: cg.classGroupShortName,
          classNumber: cg.classNumber,
          added: false,
        };
        this._isInSelected(tmp);

        this.classGroups.push(tmp);
      }
      this.editClassGroups = true;
    },
    isTimeTableAssigned(eelj, cell) {
      if (this.timetables) {
        for (var tt of this.timetables) {
          if (
            tt.eelj.id == eelj.id &&
            tt.lessonType == this.childCollection &&
            tt.weekday == cell.wNum
          ) {
            return true;
          }
        }
      }
      return false;
    },
    _addEelj(eelj, cell) {
      console.log(this.lesson.ref.path);
      if (this.isTimeTableAssigned(eelj, cell)) {
        this.lesson.ref
          .collection("calendars")
          .doc(eelj.id + "-" + cell.wNum + "-" + this.childCollection)
          .delete();
      } else {
        this.lesson.ref
          .collection("calendars")
          .doc(eelj.id + "-" + cell.wNum + "-" + this.childCollection)
          .set(
            {
              weekday: cell.wNum,
              weekdayName: cell.wName,
              eelj: eelj,
              lessonType: this.childCollection,
            },
            { merge: true }
          );
      }
    },
    _addContent() {
      this.lesson.ref.collection(this.childCollection).add({
        title: "Сэдвийн гарчигийг оруулна уу...",
        tsag: 2,
        createdAt: new Date(),
      });
    },
    _closeContentDialog() {
      this.addContentDialog = false;
      this.editedContentIndex = -1;
    },
    _editContent(content, index) {
      this.addContentDialog = true;
      this.editedContent = content;
      this.editedContentIndex = index;
    },
    _deleteContent() {
      console.log(this.editedContent);
      this.editedContent.ref.delete();
      this.editedContentIndex = -1;
      this.addContentDialog = false;
      this.editedContent = null;
    },
    _saveContent() {
      this.editedContent.ref.update(this.editedContent);
      this.addContentDialog = false;
      this.editedContentIndex = -1;
    },
    formatXDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).format("YYYY/MM/DD HH:mm");
      }
      return "-";
    },
  },
  props: {
    contents: {
      type: Array,
      required: true,
    },
    lesson: {
      type: Object,
      required: true,
    },
    childCollection: {
      type: String,
      required: true,
    },
    timetables: {
      type: Array,
      required: false,
    },
  },
};
</script>
<style>
.xeelj-table-hcell {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  width: 100%;
}
.xeelj-table-cell {
  border: 1px solid #dddddd;
  text-align: center;
  padding: 8px;
  width: 100%;
  cursor: pointer;
}
</style>